export default __webpack_public_path__ + "static/media/icon-payslip.83ffe5a2.svg";